import { apiService } from "./api.service";
import { IRegistration } from "../models/interfaces/authentication/registration.model.interface";
import { ILogin } from "../models/interfaces/authentication/login.model.interface";
import { IRegistrationResponse } from "../models/interfaces/authentication/registration-response.interface";
import { RegistrationResponseType } from "../enums/RegistrationResponseType";
import { ILoginResult } from "../models/interfaces/authentication/login-result.model.interface";
import { LoginResult } from "../models/authentication/login-result.model";
import { IForgottenPasswordRequest } from "../models/interfaces/authentication/forgotten-password-request.model.interface";
import { IResetPassword } from "../models/interfaces/authentication/reset-password.model.interface";
import { PortalUser } from "../models/authentication/portal-user.model";
import { IPortalUser } from "../models/interfaces/authentication/portal-user.model.interface";
import { IUpdatePassword } from "../models/interfaces/authentication/update-password.model.interface";
import { IUpdatePasswordResponse } from "../models/interfaces/authentication/update-password-response.interface";
import { UpdatePasswordResponseType } from "../enums/UpdatePasswordResponseType";

class AuthService {

    private static serviceInstance: AuthService;

    private constructor() { }

    public static get instance() {
        // Do you need arguments? Make it a regular method instead.
        return this.serviceInstance || (this.serviceInstance = new this());
    }

    public getCurrentUser(): IPortalUser | null {
        try {

            const portalUser: PortalUser | null = JSON.parse(localStorage.getItem("auth-user") || "null");
            return portalUser;

        } catch (e) {
            return null;
        }
    }

    public async login(
        credentials: ILogin
    ): Promise<ILoginResult> {
        return apiService.post(`/api/auth/v1/login`, credentials)
        .then((response) => {
            const data = response.data;
            const result = new LoginResult(data.success, data.result, data.token);

            // If success map User.
            if (data.success) {
                const user = data.user as IPortalUser;
                result.user = user;
                }

            return result;
        })
        .catch((error) => {
            return new LoginResult(false);
        });
    }

    public async register(
        userRegistration: IRegistration
    ): Promise<IRegistrationResponse> {
       return apiService.post(`/api/auth/v1/registration/register`, userRegistration)
            .then((response) => {
               const registrationResponse: IRegistrationResponse = {
                   success: true,
                   type: RegistrationResponseType.Success
               };
               return registrationResponse;
           })
            .catch((error) => {
                if (error.response.status === 409) {
                    const registrationResponse: IRegistrationResponse = {
                        success: false,
                        type: RegistrationResponseType.DuplicateUser
                    };
                    return registrationResponse;
                } else {
                    const registrationResponse: IRegistrationResponse = {
                        success: false,
                        type: RegistrationResponseType.Unknown
                    };
                    return registrationResponse;
               }
           });
    }

    public async forgottenPasswordRequest(
        forgottenPassword: IForgottenPasswordRequest
    ): Promise<boolean> {
        return apiService.post(`/api/auth/v1/forgottenpassword/forgot`, forgottenPassword)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
    }

    public async resetPasswordRequest(
        resetPassword: IResetPassword
    ): Promise<boolean> {
        return apiService.post(`/api/auth/v1/forgottenpassword/reset`, resetPassword)
            .then((response) => {
                return response.data.success;
            })
            .catch((error) => {
                return false;
            });
    }

    public async updatePasswordRequest(
        updatePassword: IUpdatePassword
    ): Promise<IUpdatePasswordResponse> {
        return apiService.post(`/api/auth/v1/updatepassword`, updatePassword)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                if (error.response.status === 400) {
                    const updatePasswordResponse: IUpdatePasswordResponse = {
                        success: false,
                        type: UpdatePasswordResponseType.IncorrectPassword
                    };
                    return updatePasswordResponse;
                } else {
                    const updatePasswordResponse: IUpdatePasswordResponse = {
                        success: false,
                        type: UpdatePasswordResponseType.Unknown
                    };
                    return updatePasswordResponse;
                }
            });
    }
}

// export a singleton instance in the global namespace
export const authService = AuthService.instance;
